import React, {useEffect, useRef, useState} from 'react';

import {DndContext} from '@dnd-kit/core';
import {useNavigate, useLocation} from 'react-router';

import {AppShell, Button, Group} from '@mantine/core';

import {useDisclosure} from '@mantine/hooks';

import {Sidebar} from './sidebar/sidebar';
import {useModule} from '@/hooks/useModule';
import {ModalsProvider} from '../modals/modals_provider';
import {Header} from './header/header';
import {Breadcrumbs} from './breadcrumbs/breadcrumbs';
import {useIsMobile} from '@/utils/user_agent';
import {navigateToPathForReason} from '@/modules/navigation/navigation_module';
import {OpenUploadFileModalButton} from '../modals/upload_file_modal';
import {MobileFooter} from '../mobile_footer/MobileFooter';

import '../../providers/react_query_provider';

type Props = React.PropsWithChildren;

export const ApplicationShell = (props: Props) => {
    const navigate = useNavigate();
    const loc = useLocation();

    useEffect(() => {
        (window as any).spaNavigate = (path: string) => { // used by RN process to change route
            navigateToPathForReason(navigate, 'navigate_from_spa_navigate_call', path);
        };
    }, []);

    const isMobile = useIsMobile();
    const [opened, {toggle, close, open}] = useDisclosure(false);

    const mounted = useRef(false);

    const audioPlayerModule = useModule('AudioPlayer');

    const closeSidebar = close;

    // useEffect(() => {
    //     if (!mounted.current) {
    //         mounted.current = true;
    //         return;
    //     }

    //     if (isMobile) {
    //         close();
    //     } else {
    //         open();
    //     }
    // }, [isMobile]);

    const mainClass = loc.pathname.includes('files/') ? 'file-view-page-main' : '';

    const audioPlayer = (
        <AppShell.Footer key='audio-player-footer'>
            <div
                style={{display: isMobile ? 'none' : undefined}}
            >
                <audioPlayerModule.GlobalAudioPlayer />
            </div>
        </AppShell.Footer>
    );

    return (
        <Providers>
            <AppShell
                header={{height: 60}}
                {...(isMobile ? {} : {
                    navbar: {width: 300, breakpoint: 'sm', collapsed: {mobile: !opened, desktop: !opened}},
                    padding: "md",
                    footer: {offset: true, height: 100},
                })}
            >
                <AppShell.Header>
                    <Header
                        sidebarOpened={opened}
                        toggleSidebar={isMobile ? undefined : toggle}
                    />
                </AppShell.Header>
                {!isMobile && (
                    <AppShell.Navbar
                        zIndex={199}
                    >
                        <Sidebar
                            closeSidebar={isMobile ? closeSidebar : () => { }}
                        />
                    </AppShell.Navbar>
                )}
                <AppShell.Main
                    className={mainClass}
                    style={isMobile ? { paddingBottom: 124 } : {}}
                >
                    {!isMobile && <Breadcrumbs />}
                    {/* <OpenUploadFileModalButton/> */}

                    <div style={isMobile ? undefined : {flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0}}>
                        {props.children}
                    </div>
                </AppShell.Main>
                {isMobile && <MobileFooter />}
                {audioPlayer}
            </AppShell>
        </Providers>
    );
};

const Providers = (props: React.PropsWithChildren) => {
    return (
        <DndContext>
            <ModalsProvider>
                {props.children}
            </ModalsProvider>
        </DndContext>
    );
};
